module.exports = __webpack_public_path__ + "assets/img/477af989a387550430bb5434dba72eda.png";